const MAX_DECODE_PASSES = 2;

export const normalizeTokenQueryParam = (rawToken: string | null): string | null => {
  if (typeof rawToken !== "string") {
    return null;
  }

  const trimmed = rawToken.trim();
  if (!trimmed) {
    return "";
  }

  let normalized = trimmed.replaceAll(" ", "+");

  for (let pass = 0; pass < MAX_DECODE_PASSES; pass += 1) {
    try {
      const decoded = decodeURIComponent(normalized);
      if (decoded === normalized) {
        break;
      }

      normalized = decoded.replaceAll(" ", "+");
    } catch {
      break;
    }
  }

  return normalized;
};
